import React, { useRef } from 'react';
var VeltCommentSidebarV2FilterDropdownContent = function (props) {
    var groups = props.groups, defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comment-sidebar-filter-dropdown-content-v2", { ref: ref, groups: groups ? (typeof groups === 'object' ? JSON.stringify(groups) : groups) : undefined, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltCommentSidebarV2FilterDropdownContent;
